import { SxProps, Theme } from '@mui/material/styles';

export const rootSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const headerSx: SxProps<Theme> = {
  display: 'flex',
  gap: '6px',
  flexDirection: 'column',
};

export const titleSx: SxProps<Theme> = {
  fontSize: 24,
  fontWeight: 'bold',
  color: '#CCD4FF',
};
